import { defineContent, type DefinedContent } from '@post-office/define-content';

export const registeredContent: DefinedContent<['heading', 'body', 'callToAction', 'dismiss']> =
	defineContent({
		default: {
			heading: {
				id: 'post-office.confluence-agents-mcp-nudge-banner.heading',
				defaultMessage: 'Use Confluence from your AI tools',
				description:
					'Heading on a Confluence side navigation card that introduces using Confluence from AI tools.',
				role: 'title',
			},
			body: {
				id: 'post-office.confluence-agents-mcp-nudge-banner.body',
				defaultMessage:
					'Ask questions, update docs, and set space instructions without leaving your tools.',
				description:
					'Body text on a Confluence side navigation card that summarizes what users can do after setting up MCP.',
				role: 'description',
			},
			callToAction: {
				id: 'post-office.confluence-agents-mcp-nudge-banner.call-to-action',
				defaultMessage: 'Set up MCP',
				description:
					'Button label on a Confluence side navigation card that opens the Atlassian MCP setup modal.',
			},
			dismiss: {
				id: 'post-office.confluence-agents-mcp-nudge-banner.dismiss',
				defaultMessage: 'Dismiss',
				description:
					'Accessible label for the icon button that dismisses the Confluence MCP setup nudge.',
			},
		},
	});
